import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../Components/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import Menu from "../../Components/Menu";

const Brands = () => {
    const { compId } = useParams();
    const navigate = useNavigate();
    const [brandList, setBrandList] = useState([]);
    const getBrands = (i) => {
        let config = {
            url: `${baseUrl}/brands?company_id=${compId}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                setBrandList(res?.data?.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        getBrands();
    }, []);
    return (
        <div className="container">
            <div className="category-main">
                <div className="d-flex flex-wrap w-100 cat-cards">
                    {brandList &&
                        brandList.length !== 0 &&
                        brandList.map((item) => {
                            return (
                                <div
                                    onClick={() => {
                                        navigate(
                                            "/brands/" +
                                                compId +
                                                "/" +
                                                item?.id
                                        );
                                    }}
                                    key={item.id}
                                    className="cat-card"
                                >
                                    <img src={item.image} alt="" />
                                    <span>{item.name}</span>
                                </div>
                            );
                        })}
                    <Menu active="home" />
                </div>
            </div>
        </div>
    );
};

export default Brands;
